import { render } from "./ConfirmDetailsModal.vue?vue&type=template&id=fdde06d8&scoped=true"
import script from "./ConfirmDetailsModal.vue?vue&type=script&lang=js"
export * from "./ConfirmDetailsModal.vue?vue&type=script&lang=js"

import "./ConfirmDetailsModal.vue?vue&type=style&index=0&id=fdde06d8&scoped=true&lang=scss"

import exportComponent from "/builds/swift-dental/my-swift-dental/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fdde06d8"]])

export default __exports__